/* eslint-disable sonarjs/no-duplicate-string */
import { createSystem, defaultConfig, mergeConfigs } from '@chakra-ui/react'
import { button } from '@reward-platform/lift/components/ChakraButton/themes/avios'
import { customTabs } from '@reward-platform/lift/components/Tabs/themes/avios'
import { imageCard } from '~/components/search-and-results/Card/themes/avios'
import { stickyBanner } from '@reward-platform/lift/components/StickyBanner/themes/avios'
import { snackbar } from '@reward-platform/lift/components/Snackbar/themes/avios'
import { baseTheme } from './base'

// TODO: this is all BA add in colors from vars
export const aviosTheme = createSystem(
  defaultConfig,
  mergeConfigs(baseTheme, {
    theme: {
      tokens: {
        shadows: {
          md: {
            value: '0 2px 4px rgba(0, 0, 0, 0.1)',
          },
          lg: {
            value: '0px 10px 15px -3px rgba(0, 0, 0, 0.1)',
          },
          offset: {
            value: ' 0 4px 4px -2px rgb(0 0 0 / 40%)',
          },
          brand: {
            // TODO: need to figure out this one for avios.com, using BA for now
            boxShadow: {
              value: '0 2px 4px rgba(0, 0, 0, 0.1)',
            },
            offsetShadow: {
              value: ' 0 4px 4px -2px rgb(0 0 0 / 40%)',
            },
          },
        },

        // NOTE: base foundation for vanilla chakra components and props, could match this?
        // https://github.com/chakra-ui/chakra-ui/tree/v2/packages/theme/src/foundations
        fonts: {
          heading: {
            value: 'var(--alto-sem-text-heading-font-family)',
          },
          body: {
            value: 'var(--alto-sem-text-body-font-family)',
          },
        },

        fontSizes: {
          lg: {
            value: 'var(--alto-sem-text-body-lg-font-size)',
          },
          md: {
            value: 'var(--alto-sem-text-body-md-font-size)',
          },
          sm: {
            value: 'var(--alto-sem-text-body-sm-font-size)',
          },
          xs: {
            value: 'var(--alto-sem-text-body-xs-font-size)',
          },
          xxs: {
            value: 'var(--alto-sem-text-label-xxs-font-size)',
          },
          heading: {
            xl: {
              value: 'var(--alto-sem-text-heading-xl-font-size)',
            },
            lg: {
              value: 'var(--alto-sem-text-heading-lg-font-size)',
            },
            md: {
              value: 'var(--alto-sem-text-heading-md-font-size)',
            },
            sm: {
              value: 'var(--alto-sem-text-heading-sm-font-size)',
            },
            xs: {
              value: 'var(--alto-sem-text-heading-xs-font-size)',
            },
            xxs: {
              value: 'var(--alto-sem-text-heading-2xs-font-size)',
            },
          },
        },

        spacing: {
          '5xs': {
            value: 'var(--alto-sem-space-5xs)',
          },
          '4xs': {
            value: 'var(--alto-sem-space-4xs)',
          },
          '3xs': {
            value: 'var(--alto-sem-space-3xs)',
          },
          '2xs': {
            value: 'var(--alto-sem-space-2xs)',
          },
          xs: {
            value: 'var(--alto-sem-space-xs)',
          },
          sm: {
            value: 'var(--alto-sem-space-sm)',
          },
          md: {
            value: 'var(--alto-sem-space-md)',
          },
          lg: {
            value: 'var(--alto-sem-space-lg)',
          },
          xl: {
            value: 'var(--alto-sem-space-xl)',
          },
          '2xl': {
            value: 'var(--alto-sem-space-2xl)',
          },
          '3xl': {
            value: 'var(--alto-sem-space-3xl)',
          },
          '4xl': {
            value: 'var(--alto-sem-space-4xl)',
          },
          '5xl': {
            value: 'var(--alto-sem-space-5xl)',
          },
          '6xl': {
            value: 'var(--alto-sem-space-6xl)',
          },
        },

        borders: {
          none: {
            value: 'var(--alto-sem-border-width-none)',
          },
          '0.5px': {
            value: 'var(--alto-sem-border-width-xs)',
          },
          '1px': {
            value: 'var(--alto-sem-border-width-sm)',
          },
          '2px': {
            value: 'var(--alto-sem-border-width-md)',
          },
          '4px': {
            value: 'var(--alto-sem-border-width-lg)',
          },
          '8px': {
            value: 'var(--alto-sem-border-width-xl)',
          },
        },

        radii: {
          none: {
            value: 'var(--alto-sem-radius-none)',
          },
          '6xs': {
            value: 'var(--alto-sem-radius-6xs)',
          },
          '5xs': {
            value: 'var(--alto-sem-radius-5xs)',
          },
          '4xs': {
            value: 'var(--alto-sem-radius-4xs)',
          },
          '3xs': {
            value: 'var(--alto-sem-radius-3xs)',
          },
          '2xs': {
            value: 'var(--alto-sem-radius-2xs)',
          },
          xs: {
            value: 'var(--alto-sem-radius-xs)',
          },
          sm: {
            value: 'var(--alto-sem-radius-sm)',
          },
          md: {
            value: 'var(--alto-sem-radius-md)',
          },
          lg: {
            value: 'var(--alto-sem-radius-lg)',
          },
          xl: {
            value: 'var(--alto-sem-radius-xl)',
          },
          '2xl': {
            value: 'var(--alto-sem-radius-xl)',
          },
          '3xl': {
            value: 'var(--alto-sem-radius-xl)',
          },
          full: {
            value: 'var(--alto-sem-radius-circle)',
          },
        },

        // NOTE: new breakpoints don't align with original base designs, may have to ignore for reskin
        // breakpoints: {
        //   xs: 'var(--alto-sem-breakpoint-xs-max-width)',
        //   sm: 'var(--alto-sem-breakpoint-sm-max-width)',
        //   md: 'var(--alto-sem-breakpoint-md-max-width)',
        //   lg: 'var(--alto-sem-breakpoint-lg-max-width)',
        //   xl: 'var(--alto-sem-breakpoint-xl-max-width)',
        // },
        colors: {
          // Structure taken from Alto design tokens https://zeroheight.com/8d62898ee/p/05d0b3-colour
          // Usages and standards to be added to this link as they're defined
          // TODO: look into getting a json from Alto to use here, they defo have one, they just need to serve it
          bg: {
            base: {
              value: 'var(--alto-sem-color-bg-base)',
            },
            layer1: {
              default: {
                value: 'var(--alto-sem-color-bg-layer1-default)',
              },
              hover: {
                value: 'var(--alto-sem-color-bg-layer1-hover)',
              },
              active: {
                value: 'var(--alto-sem-color-bg-layer1-active)',
              },
            },
            layer2: {
              default: {
                value: 'var(--alto-sem-color-bg-layer2-default)',
              },
              hover: {
                value: 'var(--alto-sem-color-bg-layer2-hover)',
              },
              active: {
                value: 'var(--alto-sem-color-bg-layer2-active)',
              },
            },
            layer3: {
              default: {
                value: 'var(--alto-sem-color-bg-layer3-default)',
              },
              hover: {
                value: 'var(--alto-sem-color-bg-layer3-hover)',
              },
              active: {
                value: 'var(--alto-sem-color-bg-layer3-active)',
              },
            },
            accent: {
              vibrant: {
                default: {
                  value: 'var(--alto-sem-color-bg-accent-vibrant-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-accent-vibrant-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-accent-vibrant-active)',
                },
              },
              subtle: {
                default: {
                  value: 'var(--alto-sem-color-bg-accent-subtle-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-accent-subtle-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-accent-subtle-active)',
                },
              },
              deep: {
                default: {
                  value: 'var(--alto-sem-color-bg-accent-deep-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-accent-deep-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-accent-deep-active)',
                },
              },
            },
            critical: {
              vibrant: {
                default: {
                  value: 'var(--alto-sem-color-bg-critical-vibrant-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-critical-vibrant-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-critical-vibrant-active)',
                },
              },
              subtle: {
                default: {
                  value: 'var(--alto-sem-color-bg-critical-subtle-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-critical-subtle-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-critical-subtle-active)',
                },
              },
            },
            warning: {
              vibrant: {
                default: {
                  value: 'var(--alto-sem-color-bg-warning-vibrant-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-warning-vibrant-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-warning-vibrant-active)',
                },
              },
              subtle: {
                default: {
                  value: 'var(--alto-sem-color-bg-warning-subtle-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-warning-subtle-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-warning-subtle-active)',
                },
              },
            },
            caution: {
              vibrant: {
                default: {
                  value: 'var(--alto-sem-color-bg-caution-vibrant-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-caution-vibrant-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-caution-vibrant-active)',
                },
              },
              subtle: {
                default: {
                  value: 'var(--alto-sem-color-bg-caution-subtle-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-caution-subtle-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-caution-subtle-active)',
                },
              },
            },
            success: {
              vibrant: {
                default: {
                  value: 'var(--alto-sem-color-bg-success-vibrant-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-success-vibrant-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-success-vibrant-active)',
                },
              },
              subtle: {
                default: {
                  value: 'var(--alto-sem-color-bg-success-subtle-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-success-subtle-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-success-subtle-active)',
                },
              },
            },
            information: {
              vibrant: {
                default: {
                  value: 'var(--alto-sem-color-bg-information-vibrant-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-information-vibrant-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-information-vibrant-active)',
                },
              },
              subtle: {
                default: {
                  value: 'var(--alto-sem-color-bg-information-subtle-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-information-subtle-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-information-subtle-active)',
                },
              },
            },
            inverse: {
              vibrant: {
                default: {
                  value: 'var(--alto-sem-color-bg-inverse-vibrant-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-inverse-vibrant-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-inverse-vibrant-active)',
                },
              },
              subtle: {
                default: {
                  value: 'var(--alto-sem-color-bg-inverse-subtle-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-inverse-subtle-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-inverse-subtle-active)',
                },
              },
            },
            white: {
              vibrant: {
                default: {
                  value: 'var(--alto-sem-color-bg-white-vibrant-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-white-vibrant-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-white-vibrant-active)',
                },
              },
              subtle: {
                default: {
                  value: 'var(--alto-sem-color-bg-white-subtle-default)',
                },
                hover: {
                  value: 'var(--alto-sem-color-bg-white-subtle-hover)',
                },
                active: {
                  value: 'var(--alto-sem-color-bg-white-subtle-active)',
                },
              },
            },
            disabled: {
              vibrant: {
                value: 'var(--alto-sem-color-bg-disabled-vibrant)',
              },
              subtle: {
                value: 'var(--alto-sem-color-bg-disabled-subtle)',
              },
            },
            sale: {
              vibrant: {
                value: 'var(--alto-sem-color-bg-sale-vibrant-default)',
              },
            },
            collect: {
              vibrant: {
                value: 'var(--alto-sem-color-bg-collect-vibrant-default)',
              },
            },
          },
          fg: {
            primary: {
              value: 'var(--alto-sem-color-fg-primary)',
            },
            secondary: {
              value: 'var(--alto-sem-color-fg-secondary)',
            },
            accent: {
              primary: {
                value: 'var(--alto-sem-color-fg-accent-primary)',
              },
              secondary: {
                value: 'var(--alto-sem-color-fg-accent-secondary)',
              },
              onVibrant: {
                value: 'var(--alto-sem-color-fg-accent-on-vibrant)',
              },
              onVibrantAccent: {
                value: 'var(--alto-sem-color-fg-accent-on-vibrant-accent)',
              },
              onSubtle: {
                value: 'var(--alto-sem-color-fg-accent-on-subtle)',
              },
              onDeep: {
                value: 'var(--alto-sem-color-fg-accent-on-deep)',
              },
            },
            critical: {
              primary: {
                value: 'var(--alto-sem-color-fg-critical-primary)',
              },
              onVibrant: {
                value: 'var(--alto-sem-color-fg-critical-on-vibrant)',
              },
              onSubtle: {
                value: 'var(--alto-sem-color-fg-critical-on-subtle)',
              },
            },
            warning: {
              primary: {
                value: 'var(--alto-sem-color-fg-warning-primary)',
              },
              onVibrant: {
                value: 'var(--alto-sem-color-fg-warning-on-vibrant)',
              },
              onSubtle: {
                value: 'var(--alto-sem-color-fg-warning-on-subtle)',
              },
            },
            caution: {
              primary: {
                value: 'var(--alto-sem-color-fg-caution-primary)',
              },
              onVibrant: {
                value: 'var(--alto-sem-color-fg-caution-on-vibrant)',
              },
              onSubtle: {
                value: 'var(--alto-sem-color-fg-caution-on-subtle)',
              },
            },
            success: {
              primary: {
                value: 'var(--alto-sem-color-fg-success-primary)',
              },
              onVibrant: {
                value: 'var(--alto-sem-color-fg-success-on-vibrant)',
              },
              onSubtle: {
                value: 'var(--alto-sem-color-fg-success-on-subtle)',
              },
            },
            information: {
              primary: {
                value: 'var(--alto-sem-color-fg-information-primary)',
              },
              onVibrant: {
                value: 'var(--alto-sem-color-fg-information-on-vibrant)',
              },
              onSubtle: {
                value: 'var(--alto-sem-color-fg-information-on-subtle)',
              },
            },
            inverse: {
              primary: {
                value: 'var(--alto-sem-color-fg-inverse-primary)',
              },
              onVibrant: {
                value: 'var(--alto-sem-color-fg-inverse-on-vibrant)',
              },
              onSubtle: {
                value: 'var(--alto-sem-color-fg-inverse-on-subtle)',
              },
            },
            white: {
              primary: {
                value: 'var(--alto-sem-color-fg-white-primary)',
              },
              onVibrant: {
                value: 'var(--alto-sem-color-fg-white-on-vibrant)',
              },
              onSubtle: {
                value: 'var(--alto-sem-color-fg-white-on-subtle)',
              },
            },
            disabled: {
              primary: {
                value: 'var(--alto-sem-color-fg-disabled-primary)',
              },
              onVibrant: {
                value: 'var(--alto-sem-color-fg-disabled-on-vibrant)',
              },
              onSubtle: {
                value: 'var(--alto-sem-color-fg-disabled-on-subtle)',
              },
            },
            sale: {
              primary: {
                value: 'var(--alto-sem-color-fg-sale-primary)',
              },
              onVibrant: {
                value: 'var(--alto-sem-color-fg-sale-on-vibrant)',
              },
            },
          },
          border: {
            primary: {
              default: {
                value: 'var(--alto-sem-color-border-primary-default)',
              },
              hover: {
                value: 'var(--alto-sem-color-border-primary-hover)',
              },
              active: {
                value: 'var(--alto-sem-color-border-primary-active)',
              },
            },
            secondary: {
              value: 'var(--alto-sem-color-border-secondary)',
            },
            tertiary: {
              value: 'var(--alto-sem-color-border-tertiary)',
            },
            accent: {
              value: 'var(--alto-sem-color-border-accent)',
            },
            critical: {
              value: 'var(--alto-sem-color-border-critical)',
            },
            warning: {
              value: 'var(--alto-sem-color-border-warning)',
            },
            caution: {
              value: 'var(--alto-sem-color-border-caution)',
            },
            success: {
              value: 'var(--alto-sem-color-border-success)',
            },
            information: {
              value: 'var(--alto-sem-color-border-information)',
            },
            white: {
              value: 'var(--alto-sem-color-border-white)',
            },
            inverse: {
              value: 'var(--alto-sem-color-border-inverse)',
            },
            disabled: {
              subtle: {
                value: 'var(--alto-sem-color-border-disabled-subtle)',
              },
              vibrant: {
                value: 'var(--alto-sem-color-border-disabled-vibrant)',
              },
            },
          },
          overlay: {
            scrim: {
              value: 'var(--alto-sem-color-overlay-scrim:)',
            },
            state: {
              darken: {
                hover: {
                  value: 'var(--alto-sem-color-overlay-state-darken-hover:)',
                },
                active: {
                  value: 'var(--alto-sem-color-overlay-state-darken-active:)',
                },
                invert: {
                  hover: {
                    value: 'var(--alto-sem-color-overlay-state-darken-invert-hover:)',
                  },
                  active: {
                    value: 'var(--alto-sem-color-overlay-state-darken-invert-active:)',
                  },
                },
              },
              lighten: {
                hover: {
                  value: 'var(--alto-sem-color-overlay-state-lighten-hover:)',
                },
                active: {
                  value: 'var(--alto-sem-color-overlay-state-lighten-active:)',
                },
                invert: {
                  hover: {
                    value: 'var(--alto-sem-color-overlay-state-lighten-invert-hover:)',
                  },
                  active: {
                    value: 'var(--alto-sem-color-overlay-state-lighten-invert-active:)',
                  },
                },
              },
            },
          },
          brand: {
            primary: {
              value: 'var(--alto-sem-color-brand-primary)',
            },
            secondary: {
              value: 'var(--alto-sem-color-brand-secondary)',
            },
            // Chakra theming for generic component colors, eg. Icons
            black: {
              value: 'var(--alto-sem-color-fg-primary)',
            },
            white: {
              value: 'var(--alto-sem-color-fg-inverse-primary)',
            },
            icon: {
              value: 'var(--alto-sem-color-fg-neutral-primary)',
            },
            inputIcon: {
              value: 'var(--alto-sem-color-fg-neutral-primary)',
            },
            focusOutline: {
              value: 'var(--alto-sem-color-border-accent)',
            },
          },
          error: {
            primary: {
              value: 'var(--alto-sem-color-fg-critical-primary)',
            },
          },
        },
      },

      recipes: {
        // Shared
        button,
      },

      slotRecipes: {
        // Deprecated
        customTabs,

        // Shared
        snackbar,
        stickyBanner,

        // Search & Results
        imageCard,
      },
    },
  })
)
